const apiKey = 'BA0yZVNS-vV2u-cPoamLdWcli6O-HmzvYftnVMbhw-rEuFy2b0ACIOlVKIm0jC_hS8Aq0lLJlkWZGd_UzvJoWJFKBlre9fIfu_uSIZLEFPJSdKlRZAFDMKm709rZXnYx';

const Yelp = {
    search(term,location,sortBy) {
       return fetch(`https://cors-anywhere.herokuapp.com/https://api.yelp.com/v3/businesses/search?term=${term}&location=${location}&sort_by=${sortBy}`,{
           headers: {
               Authorization: `Bearer ${apiKey}`
           }
       }).then(response => {
            return response.json();
       }).then(jsonResponse => {
           if(jsonResponse.businesses){
               return jsonResponse.businesses.map(business => ({
                    id: business.id,
                    imageSrc: business.image_url,
                    name: business.name,
                    url: business.url,
                    address: business.location.address1,
                    city: business.location.city,
                    state: business.location.state,
                    zipCode: business.location.zip_code,
                    category: business.categories[0].title,
                    rating: business.rating,
                    reviewCount: business.review_count
                   })
                )
           }
       }) 
    }
}

export default Yelp;